// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   ChevronLeft, Save, X, Plus, User, Mail, Phone, Briefcase,
//   Building2, Link2, Tag, Clock, UserCheck, CheckCircle2,
//   Circle, AlertCircle, Calendar, Edit2, ListChecks, Activity,
//   FileText, RotateCcw, ExternalLink, RefreshCw, Globe,
//   MapPin, DollarSign, Users
// } from 'lucide-react';
// import { contactsAPI, employeesAPI, tasksAPI, companiesAPI } from '../../../services/api';
// import { toast } from 'react-toastify';
// import CreateTaskModal from '../task/CreateTaskModal';
// import TaskEditDrawer from '../task/TaskEditDrawer';
// import CreateContactModal from './CreateContactModal';import CompanyEditDrawer from '../company/CompanyEditDrawer';
// /* ─── helpers ─── */
// const fmt = (val) =>
//   val ? new Date(val).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';

// const fmtTime = (val) => {
//   if (!val) return '';
//   const d = new Date(val);
//   const now = new Date();
//   const diff = now - d;
//   const mins = Math.floor(diff / 60000);
//   const hrs  = Math.floor(diff / 3600000);
//   const days = Math.floor(diff / 86400000);
//   if (mins < 1)  return 'Just now';
//   if (mins < 60) return `${mins}m ago`;
//   if (hrs < 24)  return `Today, ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
//   if (days === 1) return `Yesterday, ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
//   return fmt(val);
// };

// const LEAD_STATUS_CONFIG = {
//   NEW:              { color: 'text-blue-600',   bg: 'bg-blue-50 border-blue-200',     dot: 'bg-blue-500' },
//   CONTACTED:        { color: 'text-purple-600', bg: 'bg-purple-50 border-purple-200', dot: 'bg-purple-500' },
//   QUALIFIED:        { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',   dot: 'bg-green-500' },
//   QUALIFIED_LEAD:   { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',   dot: 'bg-green-500' },
//   UNQUALIFIED:      { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',       dot: 'bg-red-500' },
//   UNQUALIFIED_LEAD: { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',       dot: 'bg-red-500' },
//   NURTURING:        { color: 'text-amber-600',  bg: 'bg-amber-50 border-amber-200',   dot: 'bg-amber-500' },
// };

// const TASK_STATUS_CONFIG = {
//   PENDING:     { color: 'text-gray-600',  bg: 'bg-gray-100 border-gray-200',  icon: Circle },
//   IN_PROGRESS: { color: 'text-blue-600',  bg: 'bg-blue-50 border-blue-200',   icon: AlertCircle },
//   COMPLETED:   { color: 'text-green-600', bg: 'bg-green-50 border-green-200', icon: CheckCircle2 },
//   CANCELLED:   { color: 'text-red-600',   bg: 'bg-red-50 border-red-200',     icon: X },
// };

// const PRIORITY_CONFIG = {
//   HIGH:   { color: 'text-red-600',   bg: 'bg-red-50 border-red-200',     dot: 'bg-red-500',   label: 'High' },
//   MEDIUM: { color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200', dot: 'bg-amber-500', label: 'Medium' },
//   LOW:    { color: 'text-green-600', bg: 'bg-green-50 border-green-200', dot: 'bg-green-500', label: 'Low' },
// };

// const STAGE_CONFIG = {
//   PROSPECT: { color: 'text-blue-600',   bg: 'bg-blue-50 border-blue-200',    dot: 'bg-blue-500' },
//   LEAD:     { color: 'text-purple-600', bg: 'bg-purple-50 border-purple-200', dot: 'bg-purple-500' },
//   CUSTOMER: { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',  dot: 'bg-green-500' },
//   CHURNED:  { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',      dot: 'bg-red-500' },
// };

// const Badge = ({ value, config, className = '' }) => {
//   const cfg = config?.[value?.toUpperCase()] || {};
//   const Icon = cfg.icon;
//   return (
//     <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border
//       ${cfg.bg || 'bg-gray-100 border-gray-200'} ${cfg.color || 'text-gray-600'} ${className}`}>
//       {cfg.dot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />}
//       {Icon && <Icon size={11} />}
//       <span>{value?.replace(/_/g, ' ') || '—'}</span>
//     </span>
//   );
// };

// /* ─── Sidebar editable row ─── */
// const SidebarField = ({ field, editingField, editValues, display, onEdit, onSave, onCancel, onChange }) => {
//   const isEditing  = editingField === field.key;
//   const isReadonly = field.type === 'readonly';
//   const Icon = field.icon;
//   return (
//     <div className="py-2.5 border-b border-gray-50 last:border-0">
//       <div className="flex items-center gap-1.5 mb-0.5">
//         {Icon && <Icon size={11} className="text-gray-400 flex-shrink-0" />}
//         <span className="text-[11px] text-gray-400 font-medium uppercase tracking-wide">{field.label}</span>
//       </div>
//       {isEditing ? (
//         <div className="space-y-1.5 mt-1.5">
//           {field.type === 'select' ? (
//             <select value={editValues[field.key] || ''} onChange={onChange}
//               className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-400">
//               <option value="">Select…</option>
//               {field.options?.map(o => (
//                 <option key={o.id} value={o.id}>
//                   {o.name || `${o.firstName || ''} ${o.lastName || ''}`.trim() || o.email}
//                 </option>
//               ))}
//             </select>
//           ) : (
//             <input type={field.type || 'text'} value={editValues[field.key] || ''} onChange={onChange}
//               className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-400" />
//           )}
//           <div className="flex gap-1.5 justify-end">
//             <button onClick={onCancel} className="flex items-center gap-1 px-2 py-1 text-[11px] text-gray-600 bg-gray-100 hover:bg-gray-200 rounded transition-colors">
//               <X size={10} /> Cancel
//             </button>
//             <button onClick={onSave} className="flex items-center gap-1 px-2 py-1 text-[11px] text-white bg-orange-500 hover:bg-orange-600 rounded transition-colors">
//               <Save size={10} /> Save
//             </button>
//           </div>
//         </div>
//       ) : (
//         <div onClick={!isReadonly ? onEdit : undefined}
//           className={`text-xs text-gray-800 font-medium mt-0.5 rounded px-1 py-0.5 -mx-1
//             ${!isReadonly ? 'cursor-pointer hover:bg-orange-50 hover:text-orange-700 transition-colors' : ''}`}
//           title={!isReadonly ? 'Click to edit' : undefined}>
//           {!display || display === '—'
//             ? <span className="text-gray-400 italic font-normal">{isReadonly ? '—' : 'Not set'}</span>
//             : display}
//         </div>
//       )}
//     </div>
//   );
// };

// /* ─── Task Card ─── */
// const TaskCard = ({ task, onEdit }) => {
//   const statusCfg   = TASK_STATUS_CONFIG[task.status] || TASK_STATUS_CONFIG.PENDING;
//   const priorityCfg = PRIORITY_CONFIG[task.priority];
//   const StatusIcon  = statusCfg.icon;
//   return (
//     <div className="bg-white rounded-lg border border-gray-200 p-4 hover:border-blue-200 hover:shadow-sm transition-all">
//       <div className="flex items-start justify-between gap-2 mb-2">
//         <div className="flex items-start gap-2 min-w-0">
//           <StatusIcon size={15} className={`mt-0.5 flex-shrink-0 ${statusCfg.color}`} />
//           <div className="min-w-0">
//             <p className="text-sm font-semibold text-gray-800">{task.subject || '(No Subject)'}</p>
//             {task.description && (
//               <p className="text-xs text-gray-500 mt-1 line-clamp-2 leading-relaxed">{task.description}</p>
//             )}
//           </div>
//         </div>
//         <span className="text-xs text-gray-400 whitespace-nowrap flex-shrink-0">{fmtTime(task.createdAt)}</span>
//       </div>
//       <div className="flex items-center gap-2 flex-wrap mt-2">
//         {task.priority && priorityCfg && (
//           <span className={`text-xs font-medium px-2 py-0.5 rounded border ${priorityCfg.bg} ${priorityCfg.color}`}>
//             {priorityCfg.label}
//           </span>
//         )}
//         {task.type && (
//           <span className="text-xs text-teal-600 bg-teal-50 border border-teal-200 px-2 py-0.5 rounded font-medium">
//             {task.type.replace(/_/g, ' ')}
//           </span>
//         )}
//         {task.status && task.status !== 'PENDING' && <Badge value={task.status} config={TASK_STATUS_CONFIG} />}
//         {task.dueDate && (
//           <div className="flex items-center gap-1 text-xs text-gray-400">
//             <Calendar size={11} /> Due: {fmt(task.dueDate)}
//           </div>
//         )}
//       </div>
//       <div className="mt-2 pt-2 border-t border-gray-50">
//         <button onClick={() => onEdit(task)}
//           className="flex items-center gap-1 text-xs text-gray-500 hover:text-blue-600 transition-colors">
//           <Edit2 size={12} /> Edit
//         </button>
//       </div>
//     </div>
//   );
// };

// /* ─── Associated Company Card ─── */
// const AssociatedCompanyCard = ({ company, onNavigate }) => {
//   const initials = (company.companyName || '?').slice(0, 2).toUpperCase();
//   return (
//     <div className="rounded-xl border border-gray-200 overflow-hidden">
//       {/* Company header */}
//       <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 py-3 flex items-center gap-3">
//         <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0 text-white font-bold text-sm">
//           {initials}
//         </div>
//         <div className="flex-1 min-w-0">
//           <p className="text-sm font-bold text-white truncate">{company.companyName}</p>
//           <p className="text-xs text-blue-200 truncate mt-0.5">{company.industry || 'Company'}</p>
//         </div>
//         <button
//           onClick={() => onNavigate(company.id)}
//           className="p-1.5 rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
//           title="Open company profile"
//         >
//           <ExternalLink size={13} className="text-white" />
//         </button>
//       </div>

//       {/* Company details */}
//       <div className="bg-white divide-y divide-gray-50">
//         {[
//           { icon: Globe,      label: 'Website',      value: company.websiteUrl,   link: company.websiteUrl },
//           { icon: Mail,       label: 'Email',         value: company.email,        link: `mailto:${company.email}` },
//           { icon: Phone,      label: 'Phone',         value: company.phone },
//           { icon: Users,      label: 'Employees',     value: company.employeeCount },
//           { icon: DollarSign, label: 'Revenue',       value: company.annualRevenue },
//           { icon: MapPin,     label: 'City',          value: company.billingAddress?.city },
//         ].filter(f => f.value).map(f => (
//           <div key={f.label} className="flex items-center gap-2.5 px-4 py-2.5">
//             <f.icon size={12} className="text-gray-400 flex-shrink-0" />
//             <span className="text-[11px] text-gray-400 w-14 flex-shrink-0">{f.label}</span>
//             {f.link ? (
//               <a href={f.link} target="_blank" rel="noreferrer"
//                 className="text-xs text-blue-600 hover:underline truncate font-medium flex-1">
//                 {f.value}
//               </a>
//             ) : (
//               <span className="text-xs text-gray-700 font-medium truncate flex-1">{f.value}</span>
//             )}
//           </div>
//         ))}

//         {/* Badges row */}
//         {(company.leadStatus || company.companyStage) && (
//           <div className="flex flex-wrap gap-1.5 px-4 py-3">
//             {company.leadStatus   && <Badge value={company.leadStatus}   config={LEAD_STATUS_CONFIG} />}
//             {company.companyStage && <Badge value={company.companyStage} config={STAGE_CONFIG} />}
//           </div>
//         )}

//         {/* Notes snippet */}
//         {company.notes && (
//           <div className="px-4 py-3">
//             <p className="text-[11px] text-gray-400 font-medium uppercase tracking-wide mb-1">Notes</p>
//             <p className="text-xs text-gray-600 leading-relaxed line-clamp-3">{company.notes}</p>
//           </div>
//         )}

//         {/* CTA */}
//         <div className="px-4 py-3 bg-gray-50">
//           <button
//             onClick={() => onNavigate(company.id)}
//             className="w-full flex items-center justify-center gap-2 py-2 text-xs font-semibold text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-50 transition-colors"
//           >
//             <ExternalLink size={12} /> Open Company Profile
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─── Inline Create & Assign Company Modal ─── */
// const CreateAssignCompanyModal = ({ onClose, onAssigned }) => {
//   const [companyName, setCompanyName] = useState('');
//   const [industry, setIndustry]       = useState('');
//   const [loading, setLoading]         = useState(false);

//   const handleCreate = async () => {
//     if (!companyName.trim()) { toast.error('Company name is required'); return; }
//     setLoading(true);
//     try {
//       const response = await companiesAPI.addCompany({ companyName, industry: industry || undefined });
//       const newCompany = response.data;
//       toast.success(`Company "${newCompany.companyName}" created & assigned!`);
//       onAssigned({ id: newCompany.id, name: newCompany.companyName });
//       onClose();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to create company');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
//       <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
//         <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden">
//           <div className="flex items-center justify-between px-5 py-4 border-b bg-gray-50">
//             <div className="flex items-center gap-2">
//               <Building2 size={16} className="text-blue-600" />
//               <h3 className="text-sm font-semibold text-gray-900">Create &amp; Assign Company</h3>
//             </div>
//             <button onClick={onClose} className="p-1 rounded hover:bg-gray-200 text-gray-500 transition-colors">
//               <X size={16} />
//             </button>
//           </div>
//           <div className="px-5 py-4 space-y-4">
//             <div>
//               <label className="block text-xs font-medium text-gray-700 mb-1">
//                 Company Name <span className="text-red-500">*</span>
//               </label>
//               <input type="text" value={companyName} onChange={e => setCompanyName(e.target.value)}
//                 placeholder="Enter company name"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 onKeyDown={e => e.key === 'Enter' && handleCreate()} />
//             </div>
//             <div>
//               <label className="block text-xs font-medium text-gray-700 mb-1">Industry</label>
//               <select value={industry} onChange={e => setIndustry(e.target.value)}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500">
//                 <option value="">Select Industry</option>
//                 <option value="IT">IT</option>
//                 <option value="FINANCE">Finance</option>
//                 <option value="HEALTHCARE">Healthcare</option>
//                 <option value="EDUCATION">Education</option>
//                 <option value="MANUFACTURING">Manufacturing</option>
//                 <option value="RETAIL">Retail</option>
//                 <option value="OTHER">Other</option>
//               </select>
//             </div>
//           </div>
//           <div className="flex gap-2 justify-end px-5 py-4 border-t bg-gray-50">
//             <button onClick={onClose} disabled={loading}
//               className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-100 transition-colors disabled:opacity-60">
//               Cancel
//             </button>
//             <button onClick={handleCreate} disabled={loading}
//               className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-60 font-medium">
//               {loading
//                 ? <><div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" /> Creating…</>
//                 : <><Plus size={14} /> Create &amp; Assign</>
//               }
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// /* ═══════════════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════ */
// const ContactPreviewPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [contact, setContact]                   = useState(null);
//   const [loading, setLoading]                   = useState(true);
//   const [editingField, setEditingField]         = useState(null);
//   const [editValues, setEditValues]             = useState({});
//   const [employeeOptions, setEmployeeOptions]   = useState([]);
//   const [employeeNameCache, setEmployeeNameCache] = useState({});
//   const [tasks, setTasks]                       = useState([]);
//   const [tasksLoading, setTasksLoading]         = useState(false);

//   // Notes state
//   const [notes, setNotes]               = useState('');
//   const [notesLoading, setNotesLoading] = useState(false);
//   const [editingNotes, setEditingNotes] = useState(false);
//   const [notesDraft, setNotesDraft]     = useState('');
//   const [notesSaving, setNotesSaving]   = useState(false);
//   const textareaRef = useRef(null);

//   // Associated company (right panel)
//   const [associatedCompany, setAssociatedCompany]         = useState(null);
//   const [associatedCompanyLoading, setAssociatedCompanyLoading] = useState(false);
//   const [associatedCompanyError, setAssociatedCompanyError]     = useState(false);

//   // Modals
//   const [showCreateTaskModal, setShowCreateTaskModal]                   = useState(false);
//   const [showCreateAssignCompanyModal, setShowCreateAssignCompanyModal] = useState(false);
//   const [showCreateContactModal, setShowCreateContactModal]             = useState(false);
//   const [editingTask, setEditingTask]                                   = useState(null);
//   const [editingCompany, setEditingCompany]                             = useState(null);
//   const [lastAssignedCompany, setLastAssignedCompany]                   = useState(null);

//   useEffect(() => { fetchContact(); fetchEmployeeOptions(); }, [id]);

//   useEffect(() => {
//     if (!contact?.assignedTo) return;
//     const empId = contact.assignedTo;
//     if (empId in employeeNameCache) return;
//     employeesAPI.getEmployeeById(empId)
//       .then(res => {
//         const e = res.data;
//         setEmployeeNameCache(p => ({ ...p, [empId]: e.name || `${e.firstName || ''} ${e.lastName || ''}`.trim() || e.email || empId }));
//       })
//       .catch(() => setEmployeeNameCache(p => ({ ...p, [empId]: empId })));
//   }, [contact?.assignedTo]);

//   // Fetch associated company whenever contact loads/changes
//   useEffect(() => {
//     if (contact) {
//       fetchTasks();
//       fetchNotes();
//       fetchAssociatedCompany();
//     }
//   }, [contact?.id]);

//   useEffect(() => {
//     if (editingNotes && textareaRef.current) {
//       textareaRef.current.focus();
//       const len = textareaRef.current.value.length;
//       textareaRef.current.setSelectionRange(len, len);
//     }
//   }, [editingNotes]);

//   const fetchContact = async () => {
//     setLoading(true);
//     try {
//       const r = await contactsAPI.getContactById(id);
//       setContact(r.data); setEditValues(r.data);
//     } catch { toast.error('Failed to fetch contact details'); navigate('/contacts'); }
//     finally { setLoading(false); }
//   };

//   const fetchEmployeeOptions = async () => {
//     try {
//       const r = await employeesAPI.getAllEmployees();
//       setEmployeeOptions(r.data.filter(e => e.role?.includes('ATS')));
//     } catch (e) { console.error(e); }
//   };

//   const fetchTasks = async () => {
//     setTasksLoading(true);
//     try {
//       const r = await tasksAPI.gettasksbycontact(id);
//       setTasks(r.data || []);
//     } catch { toast.error('Failed to fetch tasks'); }
//     finally { setTasksLoading(false); }
//   };

//   const fetchNotes = async () => {
//     setNotesLoading(true);
//     try {
//       const r = await contactsAPI.getNotes(id);
//       const n = r.data?.notes || r.data || '';
//       setNotes(n); setNotesDraft(n);
//     } catch { console.error('Failed to fetch notes'); }
//     finally { setNotesLoading(false); }
//   };

//   const fetchAssociatedCompany = async () => {
//     setAssociatedCompanyLoading(true);
//     setAssociatedCompanyError(false);
//     try {
//       const r = await contactsAPI.getAssociatedCompany(id);
//       // 204 No Content = no company linked
//       if (r.status === 204 || !r.data) {
//         setAssociatedCompany(null);
//       } else {
//         setAssociatedCompany(r.data);
//       }
//     } catch (err) {
//       if (err.response?.status === 404 || err.response?.status === 204) {
//         setAssociatedCompany(null);
//       } else {
//         setAssociatedCompanyError(true);
//       }
//     } finally {
//       setAssociatedCompanyLoading(false);
//     }
//   };

//   const handleSaveNotes = async () => {
//     setNotesSaving(true);
//     try {
//       await contactsAPI.updateNotes(id, notesDraft);
//       setNotes(notesDraft); setEditingNotes(false);
//       toast.success('Notes saved successfully');
//     } catch { toast.error('Failed to save notes'); }
//     finally { setNotesSaving(false); }
//   };

//   const handleCancelNotes = () => { setNotesDraft(notes); setEditingNotes(false); };

//   const handleSidebarSave = async (key) => {
//     try {
//       await contactsAPI.updateContact(id, { [key]: editValues[key] });
//       setContact(p => ({ ...p, [key]: editValues[key] }));
//       setEditingField(null);
//       toast.success('Updated successfully');
//       // If companyId changed, refresh associated company panel
//       if (key === 'companyId') fetchAssociatedCompany();
//     } catch { toast.error('Failed to update field'); setEditValues(contact); }
//   };

//   const handleSidebarCancel = () => { setEditingField(null); setEditValues(contact); };

//   const handleTaskEditSave = async (taskId, payload) => {
//     try {
//       await tasksAPI.updateTask(taskId, payload);
//       toast.success('Task updated successfully');
//       setEditingTask(null);
//       fetchTasks();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to update task');
//     }
//   };

//   const handleCompanyAssigned = (company) => {
//     setLastAssignedCompany(company);
//     setShowCreateTaskModal(true);
//     // Also refresh the associated company panel
//     fetchAssociatedCompany();
//   };

//   const fields = [
//     { key: 'firstName',   label: 'First Name',   type: 'text',     icon: User },
//     { key: 'lastName',    label: 'Last Name',    type: 'text',     icon: User },
//     { key: 'email',       label: 'Email',        type: 'email',    icon: Mail },
//     { key: 'phone',       label: 'Phone',        type: 'tel',      icon: Phone },
//     { key: 'companyName', label: 'Company',      type: 'text',     icon: Building2 },
//     { key: 'companyId',   label: 'Company ID',   type: 'text',     icon: Building2 },
//     { key: 'jobTitle',    label: 'Job Title',    type: 'text',     icon: Briefcase },
//     { key: 'department',  label: 'Department',   type: 'text',     icon: Tag },
//     { key: 'leadStatus',  label: 'Lead Status',  type: 'text',     icon: Tag },
//     { key: 'leadSource',  label: 'Lead Source',  type: 'text',     icon: Tag },
//     { key: 'linkedInUrl', label: 'LinkedIn URL', type: 'text',     icon: Link2 },
//     { key: 'assignedTo',  label: 'Assigned To',  type: 'select',   icon: UserCheck, options: employeeOptions },
//     { key: 'createdAt',   label: 'Created Date', type: 'readonly', icon: Clock },
//   ];

//   const getDisplay = (f) => {
//     const v = editValues[f.key];
//     if (f.key === 'assignedTo') return employeeNameCache[v] || v || '—';
//     if (f.key === 'createdAt')  return fmt(v);
//     return v || '—';
//   };

//   const taskCounts = {
//     total:      tasks.length,
//     completed:  tasks.filter(t => t.status === 'COMPLETED').length,
//     pending:    tasks.filter(t => t.status === 'PENDING').length,
//     inProgress: tasks.filter(t => t.status === 'IN_PROGRESS').length,
//   };

//   if (loading) return (
//     <div className="flex items-center justify-center h-screen bg-gray-50">
//       <div className="flex flex-col items-center gap-3">
//         <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
//         <p className="text-sm text-gray-500">Loading contact…</p>
//       </div>
//     </div>
//   );
//   if (!contact) return <div className="p-6 text-center text-red-600">Contact not found</div>;

//   const fullName = `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || '(No Name)';
//   const initials = `${contact.firstName?.[0] || ''}${contact.lastName?.[0] || ''}`.toUpperCase() || '?';

//   return (
//     <div className="min-h-screen bg-[#f5f8fa] font-sans">

//       {/* ── Top nav ── */}
//       <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between sticky top-0 z-20 shadow-sm">
//         <div className="flex items-center gap-3">
//           <button onClick={() => navigate('/contacts')}
//             className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 transition-colors">
//             <ChevronLeft size={16} /> Contacts
//           </button>
//           <span className="text-gray-300">/</span>
//           <span className="text-sm font-medium text-gray-800 truncate max-w-xs">{fullName}</span>
//         </div>
//         <div className="flex items-center gap-2">
//           <button onClick={() => setShowCreateAssignCompanyModal(true)}
//             className="flex items-center gap-2 px-4 py-2 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors font-medium">
//             <Building2 size={15} /> Create &amp; Assign Company
//           </button>
//         </div>
//       </div>

//       {/* ── 3-column layout ── */}
//       <div className="flex h-[calc(100vh-49px)] overflow-hidden">

//         {/* ── LEFT SIDEBAR — contact details ── */}
//         <aside className="w-64 bg-white border-r border-gray-200 flex-shrink-0 h-full overflow-y-auto">
//           <div className="p-4 border-b border-gray-100">
//             <div className="flex items-center gap-3 mb-3">
//               <div className="w-11 h-11 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 text-orange-700 font-bold text-sm">
//                 {initials}
//               </div>
//               <div className="min-w-0">
//                 <h2 className="font-semibold text-gray-900 text-sm leading-tight">{fullName}</h2>
//                 <p className="text-xs text-gray-400 mt-0.5">{contact.jobTitle || 'Contact'}</p>
//               </div>
//             </div>
//             {contact.leadStatus && <Badge value={contact.leadStatus} config={LEAD_STATUS_CONFIG} />}
//           </div>
//           <div className="p-4">
//             <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-2">Contact Details</p>
//             {fields.map(field => (
//               <SidebarField
//                 key={field.key} field={field}
//                 editingField={editingField} editValues={editValues}
//                 display={getDisplay(field)}
//                 onEdit={() => setEditingField(field.key)}
//                 onSave={() => handleSidebarSave(field.key)}
//                 onCancel={handleSidebarCancel}
//                 onChange={(e) => setEditValues(p => ({ ...p, [field.key]: e.target.value }))}
//               />
//             ))}
//           </div>
//         </aside>

//         {/* ── CENTER PANEL — notes + tasks + activity (vertical) ── */}
//         <main className="flex-1 h-full overflow-y-auto min-w-0">
//           {/* Banner */}
//           <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 flex items-center gap-3">
//             <ListChecks size={20} className="text-white/80" />
//             <h1 className="text-white font-semibold text-lg tracking-wide">Lead Activity Tracker</h1>
//           </div>

//           <div className="p-5 space-y-5 max-w-2xl">

//             {/* ══ NOTES ══ */}
//             <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
//               <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
//                 <div className="flex items-center gap-2.5">
//                   <div className="w-6 h-6 rounded-md bg-gray-800 flex items-center justify-center">
//                     <FileText size={12} className="text-white" />
//                   </div>
//                   <span className="text-sm font-semibold text-gray-800">Notes</span>
//                 </div>
//                 {notes && !editingNotes && (
//                   <button onClick={() => { setNotesDraft(notes); setEditingNotes(true); }}
//                     className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors font-medium">
//                     <Edit2 size={12} /> Edit
//                   </button>
//                 )}
//               </div>
//               <div className="px-5 py-4">
//                 {notesLoading ? (
//                   <div className="flex items-center justify-center py-8">
//                     <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                   </div>
//                 ) : editingNotes ? (
//                   <div>
//                     <textarea ref={textareaRef} value={notesDraft}
//                       onChange={e => setNotesDraft(e.target.value)} rows={6}
//                       className="w-full px-4 py-3 text-sm text-gray-700 leading-relaxed bg-blue-50 border border-blue-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
//                       placeholder="Write notes about this contact…" />
//                     <div className="flex items-center justify-between mt-3">
//                       <span className="text-xs text-gray-400">{notesDraft.length} characters</span>
//                       <div className="flex items-center gap-2">
//                         <button onClick={handleCancelNotes}
//                           className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors font-medium">
//                           <RotateCcw size={11} /> Cancel
//                         </button>
//                         <button onClick={handleSaveNotes} disabled={notesSaving}
//                           className="flex items-center gap-1.5 px-4 py-1.5 text-xs text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors font-medium disabled:opacity-50">
//                           <Save size={11} /> {notesSaving ? 'Saving…' : 'Save Notes'}
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 ) : notes ? (
//                   <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">{notes}</p>
//                 ) : (
//                   <div className="text-center py-6">
//                     <FileText size={24} className="text-blue-200 mx-auto mb-2" />
//                     <p className="text-sm text-gray-400 mb-3">No notes yet</p>
//                     <button onClick={() => { setNotesDraft(''); setEditingNotes(true); }}
//                       className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium mx-auto">
//                       <Plus size={14} /> Add Notes
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* ══ TASKS ══ */}
//             <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
//               <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
//                 <div className="flex items-center gap-2.5">
//                   <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
//                     <ListChecks size={12} className="text-white" />
//                   </div>
//                   <span className="text-sm font-semibold text-gray-800">Tasks</span>
//                   {tasks.length > 0 && (
//                     <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-blue-100 text-blue-700">
//                       {tasks.length}
//                     </span>
//                   )}
//                 </div>
//               </div>
//               <div className="p-4">
//                 {tasksLoading ? (
//                   <div className="flex items-center justify-center py-10">
//                     <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                   </div>
//                 ) : tasks.length === 0 ? (
//                   <div className="text-center py-8">
//                     <CheckCircle2 size={28} className="text-gray-200 mx-auto mb-2" />
//                     <p className="text-sm text-gray-400">No tasks for this contact</p>
//                   </div>
//                 ) : (
//                   <div className="space-y-3">
//                     {tasks.map(task => (
//                       <TaskCard key={task.id} task={task} onEdit={setEditingTask} />
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* ══ ACTIVITY ══ */}
//             <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
//               <div className="flex items-center gap-2.5 px-5 py-3 border-b border-gray-100 bg-gray-50">
//                 <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
//                   <Activity size={12} className="text-white" />
//                 </div>
//                 <span className="text-sm font-semibold text-gray-800">Activity</span>
//               </div>
//               <div className="p-4">
//                 {tasks.length > 0 && (
//                   <div className="grid grid-cols-4 gap-3 mb-4">
//                     {[
//                       { label: 'Total',       value: taskCounts.total,      color: 'text-gray-700',  bg: 'bg-gray-50 border-gray-200' },
//                       { label: 'Pending',     value: taskCounts.pending,    color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200' },
//                       { label: 'In Progress', value: taskCounts.inProgress, color: 'text-blue-600',  bg: 'bg-blue-50 border-blue-200' },
//                       { label: 'Completed',   value: taskCounts.completed,  color: 'text-green-600', bg: 'bg-green-50 border-green-200' },
//                     ].map(s => (
//                       <div key={s.label} className={`rounded-lg border p-3 text-center ${s.bg}`}>
//                         <p className={`text-xl font-bold ${s.color}`}>{s.value}</p>
//                         <p className="text-xs text-gray-500 mt-0.5">{s.label}</p>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 {tasksLoading ? (
//                   <div className="flex items-center justify-center py-10">
//                     <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                   </div>
//                 ) : tasks.length === 0 ? (
//                   <div className="text-center py-8">
//                     <Activity size={28} className="text-gray-200 mx-auto mb-2" />
//                     <p className="text-sm text-gray-400">No activity yet</p>
//                     <p className="text-xs text-gray-300 mt-1">Tasks and interactions will appear here</p>
//                   </div>
//                 ) : (
//                   <div className="space-y-3">
//                     {tasks.map(task => (
//                       <TaskCard key={task.id} task={task} onEdit={setEditingTask} />
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="h-4" />
//           </div>
//         </main>

//         {/* ── RIGHT PANEL — associated company ── */}
//         <aside className="w-72 bg-white border-l border-gray-200 flex-shrink-0 h-full overflow-y-auto">
//           {/* Header */}
//           <div className="px-4 py-3.5 border-b border-gray-100 bg-gray-50 sticky top-0 z-10">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center gap-2">
//                 <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
//                   <Building2 size={12} className="text-white" />
//                 </div>
//                 <span className="text-sm font-semibold text-gray-800">Associated Company</span>
//               </div>
//               <button onClick={fetchAssociatedCompany}
//                 className="p-1 rounded hover:bg-gray-200 transition-colors" title="Refresh">
//                 <RefreshCw size={13} className="text-gray-400" />
//               </button>
//             </div>
//           </div>

//           {/* Company content */}
//           <div className="p-3">
//             {associatedCompanyLoading ? (
//               <div className="flex items-center justify-center py-16">
//                 <div className="flex flex-col items-center gap-2">
//                   <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                   <p className="text-xs text-gray-400">Loading company…</p>
//                 </div>
//               </div>
//             ) : associatedCompanyError ? (
//               <div className="text-center py-12 px-3">
//                 <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-3">
//                   <Building2 size={20} className="text-red-300" />
//                 </div>
//                 <p className="text-sm font-medium text-gray-500 mb-1">Failed to load</p>
//                 <button onClick={fetchAssociatedCompany}
//                   className="mt-2 text-xs text-blue-600 hover:underline">
//                   Try again
//                 </button>
//               </div>
//             ) : associatedCompany ? (
//               <>
//                 <AssociatedCompanyCard
//                   company={associatedCompany}
//                   onNavigate={(companyId) => navigate(`/company/${companyId}`)}
//                 />
//                 <button
//                   onClick={() => setEditingCompany(associatedCompany)}
//                   className="w-full mt-3 inline-flex items-center justify-center gap-2 px-4 py-2 text-xs font-semibold bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors border border-blue-200"
//                 >
//                   <Edit2 size={12} /> Edit Company
//                 </button>
//               </>
//             ) : (
//               <div className="text-center py-12 px-3">
//                 <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-3">
//                   <Building2 size={20} className="text-blue-300" />
//                 </div>
//                 <p className="text-sm font-medium text-gray-500 mb-1">No company linked</p>
//                 <p className="text-xs text-gray-400 leading-relaxed mb-4">
//                   Assign a company to this contact by setting the Company ID in the sidebar or using "Create &amp; Assign Company".
//                 </p>
//                 <button
//                   onClick={() => setShowCreateAssignCompanyModal(true)}
//                   className="inline-flex items-center gap-2 px-4 py-2 text-xs font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
//                 >
//                   <Plus size={12} /> Create &amp; Assign
//                 </button>
//               </div>
//             )}
//           </div>
//         </aside>

//       </div>

//       {/* ══ MODALS & DRAWERS ══ */}
//       {showCreateAssignCompanyModal && (
//         <CreateAssignCompanyModal
//           onClose={() => setShowCreateAssignCompanyModal(false)}
//           onAssigned={handleCompanyAssigned}
//         />
//       )}

//       {showCreateTaskModal && (
//         <CreateTaskModal
//           onClose={() => { setShowCreateTaskModal(false); setLastAssignedCompany(null); }}
//           onCreate={() => {
//             setShowCreateTaskModal(false);
//             setLastAssignedCompany(null);
//             toast.success('Task created successfully');
//             fetchTasks();
//           }}
//           linkedContact={contact.id}
//           linkedContactName={`${contact.firstName || ''} ${contact.lastName || ''}`.trim()}
//           linkedAccount={lastAssignedCompany?.id || ''}
//           linkedAccountName={lastAssignedCompany?.name || ''}
//         />
//       )}

//       {editingTask && (
//         <TaskEditDrawer
//           task={editingTask}
//           onClose={() => setEditingTask(null)}
//           onSave={handleTaskEditSave}
//         />
//       )}

//       {editingCompany && (
//         <CompanyEditDrawer
//           company={editingCompany}
//           onClose={() => setEditingCompany(null)}
//           onSave={() => {
//             setEditingCompany(null);
//             fetchAssociatedCompany();
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default ContactPreviewPage;

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  ChevronLeft, Save, X, Plus, User, Mail, Phone, Briefcase,
  Building2, Link2, Tag, Clock, UserCheck, CheckCircle2,
  Circle, AlertCircle, Calendar, Edit2, ListChecks, Activity,
  FileText, RotateCcw, ExternalLink, RefreshCw, Globe,
  MapPin, DollarSign, Users
} from 'lucide-react';
import { contactsAPI, employeesAPI, tasksAPI, companiesAPI } from '../../../services/api';
import { toast } from 'react-toastify';
import CreateTaskModal from '../task/CreateTaskModal';
import TaskEditDrawer from '../task/TaskEditDrawer';
import CompanyEditDrawer from '../company/CompanyEditDrawer';

/* ─── helpers ─── */
const fmt = (val) =>
  val ? new Date(val).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';

const fmtTime = (val) => {
  if (!val) return '';
  const d = new Date(val);
  const now = new Date();
  const diff = now - d;
  const mins = Math.floor(diff / 60000);
  const hrs  = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  if (mins < 1)  return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  if (hrs < 24)  return `Today, ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
  if (days === 1) return `Yesterday, ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
  return fmt(val);
};

const LEAD_STATUS_CONFIG = {
  NEW:              { color: 'text-blue-600',   bg: 'bg-blue-50 border-blue-200',     dot: 'bg-blue-500' },
  CONTACTED:        { color: 'text-purple-600', bg: 'bg-purple-50 border-purple-200', dot: 'bg-purple-500' },
  QUALIFIED:        { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',   dot: 'bg-green-500' },
  QUALIFIED_LEAD:   { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',   dot: 'bg-green-500' },
  UNQUALIFIED:      { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',       dot: 'bg-red-500' },
  UNQUALIFIED_LEAD: { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',       dot: 'bg-red-500' },
  NURTURING:        { color: 'text-amber-600',  bg: 'bg-amber-50 border-amber-200',   dot: 'bg-amber-500' },
};

const TASK_STATUS_CONFIG = {
  PENDING:     { color: 'text-gray-600',  bg: 'bg-gray-100 border-gray-200',  icon: Circle },
  IN_PROGRESS: { color: 'text-blue-600',  bg: 'bg-blue-50 border-blue-200',   icon: AlertCircle },
  COMPLETED:   { color: 'text-green-600', bg: 'bg-green-50 border-green-200', icon: CheckCircle2 },
  CANCELLED:   { color: 'text-red-600',   bg: 'bg-red-50 border-red-200',     icon: X },
};

const PRIORITY_CONFIG = {
  HIGH:   { color: 'text-red-600',   bg: 'bg-red-50 border-red-200',     dot: 'bg-red-500',   label: 'High' },
  MEDIUM: { color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200', dot: 'bg-amber-500', label: 'Medium' },
  LOW:    { color: 'text-green-600', bg: 'bg-green-50 border-green-200', dot: 'bg-green-500', label: 'Low' },
};

const STAGE_CONFIG = {
  PROSPECT: { color: 'text-blue-600',   bg: 'bg-blue-50 border-blue-200',    dot: 'bg-blue-500' },
  LEAD:     { color: 'text-purple-600', bg: 'bg-purple-50 border-purple-200', dot: 'bg-purple-500' },
  CUSTOMER: { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',  dot: 'bg-green-500' },
  CHURNED:  { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',      dot: 'bg-red-500' },
};

/* ─── Enum option lists (matching CreateContactModal exactly) ─── */
const LEAD_STATUS_OPTIONS = [
  { value: 'NEW',               label: 'New' },
  { value: 'PROSPECT',          label: 'Prospect' },
  { value: 'CONTACTED',         label: 'Contacted' },
  { value: 'QUALIFIED_LEAD',    label: 'Qualified Lead' },
  { value: 'UNQUALIFIED_LEAD',  label: 'Unqualified Lead' },
  { value: 'NURTURING',         label: 'Nurturing' },
  { value: 'MEETING_SCHEDULED', label: 'Meeting Scheduled' },
  { value: 'PROPOSAL_SENT',     label: 'Proposal Sent' },
  { value: 'NEGOTIATION',       label: 'Negotiation' },
  { value: 'CONTRACT_SENT',     label: 'Contract Sent' },
  { value: 'WON_CUSTOMER',      label: 'Won Customer' },
  { value: 'LOST',              label: 'Lost' },
  { value: 'ON_HOLD',           label: 'On Hold' },
  { value: 'OTHER',             label: 'Other' },
];

const LEAD_SOURCE_OPTIONS = [
  { value: 'GOOGLE_ADS',     label: 'Google Ads' },
  { value: 'LINKEDIN_ADS',   label: 'LinkedIn Ads' },
  { value: 'FACEBOOK_ADS',   label: 'Facebook Ads' },
  { value: 'INSTAGRAM_ADS',  label: 'Instagram Ads' },
  { value: 'WHATSAPP_ADS',   label: 'WhatsApp Ads' },
  { value: 'TELEGRAM_ADS',   label: 'Telegram Ads' },
  { value: 'CONTACT_FORM',   label: 'Contact Form' },
  { value: 'EMAIL_CAMPAIGN',  label: 'Email Campaign' },
  { value: 'COLD_CALLING',   label: 'Cold Calling' },
  { value: 'REFERRAL',       label: 'Referral' },
  { value: 'EVENTS',         label: 'Events' },
  { value: 'TRADE_SHOWS',    label: 'Trade Shows' },
  { value: 'PARTNERSHIP',    label: 'Partnership' },
  { value: 'ORGANIC_SEARCH', label: 'Organic Search' },
  { value: 'PAPER_ADS',      label: 'Paper Ads' },
  { value: 'OTHER',          label: 'Other' },
];

const DEPARTMENT_OPTIONS = [
  { value: 'EXECUTIVE_LEADERSHIP',  label: 'Executive Leadership' },
  { value: 'HUMAN_RESOURCES',       label: 'Human Resources' },
  { value: 'TALENT_ACQUISITION',    label: 'Talent Acquisition' },
  { value: 'SALES',                 label: 'Sales' },
  { value: 'MARKETING',             label: 'Marketing' },
  { value: 'CUSTOMER_SUPPORT',      label: 'Customer Support' },
  { value: 'FINANCE',               label: 'Finance' },
  { value: 'LEGAL',                 label: 'Legal' },
  { value: 'IT',                    label: 'IT' },
  { value: 'ENGINEERING',           label: 'Engineering' },
  { value: 'PRODUCT_MANAGEMENT',    label: 'Product Management' },
  { value: 'DESIGN_UX',             label: 'Design & UX' },
  { value: 'OPERATIONS',            label: 'Operations' },
  { value: 'BUSINESS_DEVELOPMENT',  label: 'Business Development' },
  { value: 'PROCUREMENT',           label: 'Procurement' },
  { value: 'MANUFACTURING',         label: 'Manufacturing' },
  { value: 'LOGISTICS',             label: 'Logistics' },
  { value: 'QUALITY_ASSURANCE',     label: 'Quality Assurance' },
  { value: 'RESEARCH_DEVELOPMENT',  label: 'Research & Development' },
  { value: 'TRAINING_LD',           label: 'Training & L&D' },
  { value: 'SECURITY_RISK',         label: 'Security & Risk' },
  { value: 'PR_COMMUNICATIONS',     label: 'PR & Communications' },
  { value: 'FACILITIES_MANAGEMENT', label: 'Facilities Management' },
  { value: 'CONSULTING',            label: 'Consulting' },
  { value: 'HEALTHCARE',            label: 'Healthcare' },
  { value: 'EDUCATION',             label: 'Education' },
  { value: 'DATA_ANALYTICS',        label: 'Data & Analytics' },
  { value: 'INVESTOR_RELATIONS',    label: 'Investor Relations' },
  { value: 'CORPORATE_STRATEGY',    label: 'Corporate Strategy' },
  { value: 'OTHER',                 label: 'Other' },
];

const Badge = ({ value, config, className = '' }) => {
  const cfg = config?.[value?.toUpperCase()] || {};
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border
      ${cfg.bg || 'bg-gray-100 border-gray-200'} ${cfg.color || 'text-gray-600'} ${className}`}>
      {cfg.dot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />}
      {Icon && <Icon size={11} />}
      <span>{value?.replace(/_/g, ' ') || '—'}</span>
    </span>
  );
};

/* ─── Sidebar editable row ─── */
const SidebarField = ({ field, editingField, editValues, display, onEdit, onSave, onCancel, onChange }) => {
  const isEditing  = editingField === field.key;
  const isReadonly = field.type === 'readonly';
  const Icon = field.icon;

  // ✅ Renders the correct input type based on field config
  const renderInput = () => {
    // Employee dropdown (type='select' with options array)
    if (field.type === 'select' && field.options) {
      return (
        <select
          value={editValues[field.key] || ''}
          onChange={onChange}
          className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-400"
        >
          <option value="">Select…</option>
          {field.options.map(o => (
            <option key={o.id} value={o.id}>
              {o.name || `${o.firstName || ''} ${o.lastName || ''}`.trim() || o.email}
            </option>
          ))}
        </select>
      );
    }
    // Enum dropdown (type='enum' with enumOptions array)
    if (field.enumOptions) {
      return (
        <select
          value={editValues[field.key] || ''}
          onChange={onChange}
          className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-400"
        >
          <option value="">Select…</option>
          {field.enumOptions.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      );
    }
    // Plain text / email / tel input
    return (
      <input
        type={field.type === 'enum' ? 'text' : (field.type || 'text')}
        value={editValues[field.key] || ''}
        onChange={onChange}
        className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-400"
      />
    );
  };

  return (
    <div className="py-2.5 border-b border-gray-50 last:border-0">
      <div className="flex items-center gap-1.5 mb-0.5">
        {Icon && <Icon size={11} className="text-gray-400 flex-shrink-0" />}
        <span className="text-[11px] text-gray-400 font-medium uppercase tracking-wide">{field.label}</span>
      </div>
      {isEditing ? (
        <div className="space-y-1.5 mt-1.5">
          {renderInput()}
          {/* ✅ Save & Cancel always visible when editing */}
          <div className="flex gap-1.5 justify-end">
            <button
              onClick={onCancel}
              className="flex items-center gap-1 px-2 py-1 text-[11px] text-gray-600 bg-gray-100 hover:bg-gray-200 rounded transition-colors"
            >
              <X size={10} /> Cancel
            </button>
            <button
              onClick={onSave}
              className="flex items-center gap-1 px-2 py-1 text-[11px] text-white bg-orange-500 hover:bg-orange-600 rounded transition-colors"
            >
              <Save size={10} /> Save
            </button>
          </div>
        </div>
      ) : (
        <div
          onClick={!isReadonly ? onEdit : undefined}
          className={`text-xs text-gray-800 font-medium mt-0.5 rounded px-1 py-0.5 -mx-1
            ${!isReadonly ? 'cursor-pointer hover:bg-orange-50 hover:text-orange-700 transition-colors' : ''}`}
          title={!isReadonly ? 'Click to edit' : undefined}
        >
          {!display || display === '—'
            ? <span className="text-gray-400 italic font-normal">{isReadonly ? '—' : 'Not set'}</span>
            : display}
        </div>
      )}
    </div>
  );
};

/* ─── Task Card ─── */
const TaskCard = ({ task, onEdit }) => {
  const statusCfg   = TASK_STATUS_CONFIG[task.status] || TASK_STATUS_CONFIG.PENDING;
  const priorityCfg = PRIORITY_CONFIG[task.priority];
  const StatusIcon  = statusCfg.icon;
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 hover:border-blue-200 hover:shadow-sm transition-all">
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex items-start gap-2 min-w-0">
          <StatusIcon size={15} className={`mt-0.5 flex-shrink-0 ${statusCfg.color}`} />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-gray-800">{task.subject || '(No Subject)'}</p>
            {task.description && (
              <p className="text-xs text-gray-500 mt-1 line-clamp-2 leading-relaxed">{task.description}</p>
            )}
          </div>
        </div>
        <span className="text-xs text-gray-400 whitespace-nowrap flex-shrink-0">{fmtTime(task.createdAt)}</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap mt-2">
        {task.priority && priorityCfg && (
          <span className={`text-xs font-medium px-2 py-0.5 rounded border ${priorityCfg.bg} ${priorityCfg.color}`}>
            {priorityCfg.label}
          </span>
        )}
        {task.type && (
          <span className="text-xs text-teal-600 bg-teal-50 border border-teal-200 px-2 py-0.5 rounded font-medium">
            {task.type.replace(/_/g, ' ')}
          </span>
        )}
        {task.status && task.status !== 'PENDING' && <Badge value={task.status} config={TASK_STATUS_CONFIG} />}
        {task.dueDate && (
          <div className="flex items-center gap-1 text-xs text-gray-400">
            <Calendar size={11} /> Due: {fmt(task.dueDate)}
          </div>
        )}
      </div>
      <div className="mt-2 pt-2 border-t border-gray-50">
        <button onClick={() => onEdit(task)}
          className="flex items-center gap-1 text-xs text-gray-500 hover:text-blue-600 transition-colors">
          <Edit2 size={12} /> Edit
        </button>
      </div>
    </div>
  );
};

/* ─── Associated Company Card ─── */
const AssociatedCompanyCard = ({ company, onNavigate }) => {
  const initials = (company.companyName || '?').slice(0, 2).toUpperCase();
  return (
    <div className="rounded-xl border border-gray-200 overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 py-3 flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0 text-white font-bold text-sm">
          {initials}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-white truncate">{company.companyName}</p>
          <p className="text-xs text-blue-200 truncate mt-0.5">{company.industry || 'Company'}</p>
        </div>
        <button
          onClick={() => onNavigate(company.id)}
          className="p-1.5 rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
          title="Open company profile"
        >
          <ExternalLink size={13} className="text-white" />
        </button>
      </div>

      <div className="bg-white divide-y divide-gray-50">
        {[
          { icon: Globe,      label: 'Website',  value: company.websiteUrl,   link: company.websiteUrl },
          { icon: Mail,       label: 'Email',    value: company.email,        link: `mailto:${company.email}` },
          { icon: Phone,      label: 'Phone',    value: company.phone },
          { icon: Users,      label: 'Employees',value: company.employeeCount },
          { icon: DollarSign, label: 'Revenue',  value: company.annualRevenue },
          { icon: MapPin,     label: 'City',     value: company.billingAddress?.city },
        ].filter(f => f.value).map(f => (
          <div key={f.label} className="flex items-center gap-2.5 px-4 py-2.5">
            <f.icon size={12} className="text-gray-400 flex-shrink-0" />
            <span className="text-[11px] text-gray-400 w-14 flex-shrink-0">{f.label}</span>
            {f.link ? (
              <a href={f.link} target="_blank" rel="noreferrer"
                className="text-xs text-blue-600 hover:underline truncate font-medium flex-1">
                {f.value}
              </a>
            ) : (
              <span className="text-xs text-gray-700 font-medium truncate flex-1">{f.value}</span>
            )}
          </div>
        ))}

        {(company.leadStatus || company.companyStage) && (
          <div className="flex flex-wrap gap-1.5 px-4 py-3">
            {company.leadStatus   && <Badge value={company.leadStatus}   config={LEAD_STATUS_CONFIG} />}
            {company.companyStage && <Badge value={company.companyStage} config={STAGE_CONFIG} />}
          </div>
        )}

        {company.notes && (
          <div className="px-4 py-3">
            <p className="text-[11px] text-gray-400 font-medium uppercase tracking-wide mb-1">Notes</p>
            <p className="text-xs text-gray-600 leading-relaxed line-clamp-3">{company.notes}</p>
          </div>
        )}

        <div className="px-4 py-3 bg-gray-50">
          <button
            onClick={() => onNavigate(company.id)}
            className="w-full flex items-center justify-center gap-2 py-2 text-xs font-semibold text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-50 transition-colors"
          >
            <ExternalLink size={12} /> Open Company Profile
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─── Create & Assign Company Modal ─── */
const CreateAssignCompanyModal = ({ onClose, onAssigned, contactId }) => {
  const [companyName, setCompanyName] = useState('');
  const [industry, setIndustry]       = useState('');
  const [loading, setLoading]         = useState(false);

  const handleCreate = async () => {
    if (!companyName.trim()) { toast.error('Company name is required'); return; }
    setLoading(true);
    try {
      const response = await companiesAPI.addCompany({ companyName, industry: industry || undefined });
      const newCompany = response.data;

      // ✅ Link this contact to the newly created company
      await contactsAPI.updateContact(contactId, { companyId: newCompany.id });

      toast.success(`Company "${newCompany.companyName}" created & assigned!`);
      onAssigned({ id: newCompany.id, name: newCompany.companyName });
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create or assign company');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden">
          <div className="flex items-center justify-between px-5 py-4 border-b bg-gray-50">
            <div className="flex items-center gap-2">
              <Building2 size={16} className="text-blue-600" />
              <h3 className="text-sm font-semibold text-gray-900">Create &amp; Assign Company</h3>
            </div>
            <button onClick={onClose} className="p-1 rounded hover:bg-gray-200 text-gray-500 transition-colors">
              <X size={16} />
            </button>
          </div>
          <div className="px-5 py-4 space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Company Name <span className="text-red-500">*</span>
              </label>
              <input type="text" value={companyName} onChange={e => setCompanyName(e.target.value)}
                placeholder="Enter company name"
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                onKeyDown={e => e.key === 'Enter' && handleCreate()} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Industry</label>
              <select value={industry} onChange={e => setIndustry(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500">
                <option value="">Select Industry</option>
                <option value="IT">IT</option>
                <option value="FINANCE">Finance</option>
                <option value="HEALTHCARE">Healthcare</option>
                <option value="EDUCATION">Education</option>
                <option value="MANUFACTURING">Manufacturing</option>
                <option value="RETAIL">Retail</option>
                <option value="OTHER">Other</option>
              </select>
            </div>
          </div>
          <div className="flex gap-2 justify-end px-5 py-4 border-t bg-gray-50">
            <button onClick={onClose} disabled={loading}
              className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-100 transition-colors disabled:opacity-60">
              Cancel
            </button>
            <button onClick={handleCreate} disabled={loading}
              className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-60 font-medium">
              {loading
                ? <><div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" /> Creating…</>
                : <><Plus size={14} /> Create &amp; Assign</>
              }
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

/* ═══════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════════════════ */
const ContactPreviewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [contact, setContact]                     = useState(null);
  const [loading, setLoading]                     = useState(true);
  const [editingField, setEditingField]           = useState(null);
  const [editValues, setEditValues]               = useState({});
  const [employeeOptions, setEmployeeOptions]     = useState([]);
  const [employeeNameCache, setEmployeeNameCache] = useState({});
  const [tasks, setTasks]                         = useState([]);
  const [tasksLoading, setTasksLoading]           = useState(false);

  // Notes state
  const [notes, setNotes]               = useState('');
  const [notesLoading, setNotesLoading] = useState(false);
  const [editingNotes, setEditingNotes] = useState(false);
  const [notesDraft, setNotesDraft]     = useState('');
  const [notesSaving, setNotesSaving]   = useState(false);
  const textareaRef = useRef(null);

  // Associated company (right panel)
  const [associatedCompany, setAssociatedCompany]               = useState(null);
  const [associatedCompanyLoading, setAssociatedCompanyLoading] = useState(false);
  const [associatedCompanyError, setAssociatedCompanyError]     = useState(false);

  // Modals
  const [showCreateTaskModal, setShowCreateTaskModal]                   = useState(false);
  const [showCreateAssignCompanyModal, setShowCreateAssignCompanyModal] = useState(false);
  const [editingTask, setEditingTask]                                   = useState(null);
  const [editingCompany, setEditingCompany]                             = useState(null);
  const [lastAssignedCompany, setLastAssignedCompany]                   = useState(null);

  useEffect(() => { fetchContact(); fetchEmployeeOptions(); }, [id]);

  useEffect(() => {
    if (!contact?.assignedTo) return;
    const empId = contact.assignedTo;
    if (empId in employeeNameCache) return;
    employeesAPI.getEmployeeById(empId)
      .then(res => {
        const e = res.data;
        setEmployeeNameCache(p => ({ ...p, [empId]: e.name || `${e.firstName || ''} ${e.lastName || ''}`.trim() || e.email || empId }));
      })
      .catch(() => setEmployeeNameCache(p => ({ ...p, [empId]: empId })));
  }, [contact?.assignedTo]);

  useEffect(() => {
    if (!contact?.notesLastEditedBy) return;
    const editorId = contact.notesLastEditedBy;
    if (editorId in employeeNameCache) return;
    employeesAPI.getEmployeeById(editorId)
      .then(res => {
        const e = res.data;
        setEmployeeNameCache(p => ({ ...p, [editorId]: e.name || `${e.firstName || ''} ${e.lastName || ''}`.trim() || e.email || editorId }));
      })
      .catch(() => setEmployeeNameCache(p => ({ ...p, [editorId]: editorId })));
  }, [contact?.notesLastEditedBy]);

  useEffect(() => {
    if (contact) {
      fetchTasks();
      fetchNotes();
      fetchAssociatedCompany();
    }
  }, [contact?.id]);

  useEffect(() => {
    if (editingNotes && textareaRef.current) {
      textareaRef.current.focus();
      const len = textareaRef.current.value.length;
      textareaRef.current.setSelectionRange(len, len);
    }
  }, [editingNotes]);

  const fetchContact = async () => {
    setLoading(true);
    try {
      const r = await contactsAPI.getContactById(id);
      setContact(r.data); setEditValues(r.data);
    } catch { toast.error('Failed to fetch contact details'); navigate('/contacts'); }
    finally { setLoading(false); }
  };

  const fetchEmployeeOptions = async () => {
    try {
      const r = await employeesAPI.getAllEmployees();
      setEmployeeOptions(r.data.filter(e => Array.isArray(e.roles) && e.roles.some(r => r === 'CRM' || r === 'ROLE_CRM')));
    } catch (e) { console.error(e); }
  };

  const fetchTasks = async () => {
  setTasksLoading(true);
  try {
    const r = await tasksAPI.gettasksbycompany(id);
    const sorted = (r.data || []).sort((a, b) => {
      if (!a.dueDate) return 1;
      if (!b.dueDate) return -1;
      return new Date(b.dueDate) - new Date(a.dueDate); // latest first
    });
    setTasks(sorted);
  } catch { toast.error('Failed to fetch tasks'); }
  finally { setTasksLoading(false); }
};

  const fetchNotes = async () => {
    setNotesLoading(true);
    try {
      const r = await contactsAPI.getNotes(id);
      const n = typeof r.data?.notes === 'string' ? r.data.notes : '';
      setNotes(n); setNotesDraft(n);
    } catch { console.error('Failed to fetch notes'); }
    finally { setNotesLoading(false); }
  };

  const fetchAssociatedCompany = async () => {
    setAssociatedCompanyLoading(true);
    setAssociatedCompanyError(false);
    try {
      const r = await contactsAPI.getAssociatedCompany(id);
      if (r.status === 204 || !r.data) {
        setAssociatedCompany(null);
      } else {
        setAssociatedCompany(r.data);
      }
    } catch (err) {
      if (err.response?.status === 404 || err.response?.status === 204) {
        setAssociatedCompany(null);
      } else {
        setAssociatedCompanyError(true);
      }
    } finally {
      setAssociatedCompanyLoading(false);
    }
  };

  const handleSaveNotes = async () => {
    setNotesSaving(true);
    try {
      await contactsAPI.updateNotes(id, notesDraft);
      setNotes(notesDraft); setEditingNotes(false);
      toast.success('Notes saved successfully');
    } catch { toast.error('Failed to save notes'); }
    finally { setNotesSaving(false); }
  };

  const handleCancelNotes = () => { setNotesDraft(notes); setEditingNotes(false); };

  const normalizePhone = (val) => {
    if (!val) return val;
    let d = val.replace(/\D/g, "");
    if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
    if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
    return d.length === 10 ? d : val;
  };

  const handleSidebarSave = async (key) => {
    let value = editValues[key];
    if (key === "phone") {
      value = normalizePhone(value);
      if (!value || !/^\d{10}$/.test(value) || !/^[6-9]/.test(value)) {
        toast.error("Phone number must be exactly 10 digits and start with 6, 7, 8, or 9.");
        return;
      }
    }
    try {
      await contactsAPI.updateContact(id, { [key]: value });
      setContact(p => ({ ...p, [key]: value }));
      setEditingField(null);
      toast.success('Updated successfully');
      if (key === 'companyId') fetchAssociatedCompany();
    } catch { toast.error('Failed to update field'); setEditValues(contact); }
  };

  const handleSidebarCancel = () => { setEditingField(null); setEditValues(contact); };

  const handleTaskEditSave = async (taskId, payload) => {
    try {
      await tasksAPI.updateTask(taskId, payload);
      toast.success('Task updated successfully');
      setEditingTask(null);
      fetchTasks();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update task');
    }
  };

  const handleCompanyAssigned = (company) => {
    setLastAssignedCompany(company);
    // ✅ Update local state so sidebar companyId reflects immediately
    setContact(p => ({ ...p, companyId: company.id }));
    setEditValues(p => ({ ...p, companyId: company.id }));
    fetchAssociatedCompany();
  };

  // ✅ department, leadStatus, leadSource use enumOptions → renders <select> in SidebarField
  const fields = [
    { key: 'firstName',   label: 'First Name',   type: 'text',     icon: User },
    { key: 'lastName',    label: 'Last Name',    type: 'text',     icon: User },
    { key: 'email',       label: 'Email',        type: 'email',    icon: Mail },
    { key: 'phone',       label: 'Phone',        type: 'tel',      icon: Phone },
    { key: 'companyName', label: 'Company',      type: 'text',     icon: Building2 },
    { key: 'companyId',   label: 'Company ID',   type: 'text',     icon: Building2 },
    { key: 'jobTitle',    label: 'Job Title',    type: 'text',     icon: Briefcase },
    { key: 'department',  label: 'Department',   type: 'text',     icon: Tag,      enumOptions: DEPARTMENT_OPTIONS },
    { key: 'leadStatus',  label: 'Lead Status',  type: 'text',     icon: Tag,      enumOptions: LEAD_STATUS_OPTIONS },
    { key: 'leadSource',  label: 'Lead Source',  type: 'text',     icon: Tag,      enumOptions: LEAD_SOURCE_OPTIONS },
    { key: 'linkedInUrl', label: 'LinkedIn URL', type: 'text',     icon: Link2 },
    { key: 'assignedTo',  label: 'Assigned To',  type: 'select',   icon: UserCheck, options: employeeOptions },
    { key: 'createdAt',   label: 'Created Date', type: 'readonly', icon: Clock },
  ];

  const getDisplay = (f) => {
    const v = editValues[f.key];
    if (f.key === 'assignedTo') return employeeNameCache[v] || v || '—';
    if (f.key === 'createdAt')  return fmt(v);
    // ✅ Show human-readable label for enum fields
    if (f.enumOptions) {
      const opt = f.enumOptions.find(o => o.value === v);
      return opt ? opt.label : (v?.replace(/_/g, ' ') || '—');
    }
    return v || '—';
  };

  const taskCounts = {
    total:      tasks.length,
    completed:  tasks.filter(t => t.status === 'COMPLETED').length,
    pending:    tasks.filter(t => t.status === 'PENDING').length,
    inProgress: tasks.filter(t => t.status === 'IN_PROGRESS').length,
  };

  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-gray-500">Loading contact…</p>
      </div>
    </div>
  );
  if (!contact) return <div className="p-6 text-center text-red-600">Contact not found</div>;

  const fullName = `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || '(No Name)';
  const initials = `${contact.firstName?.[0] || ''}${contact.lastName?.[0] || ''}`.toUpperCase() || '?';

  // ✅ Key flag: hide Create & Assign + Edit buttons when company already linked
  const hasAssociatedCompany = !!associatedCompany;

  return (
    <div className="min-h-screen bg-[#f5f8fa] font-sans">

      {/* ── Top nav ── */}
      <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between sticky top-0 z-20 shadow-sm">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate('/contacts')}
            className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 transition-colors">
            <ChevronLeft size={16} /> Contacts
          </button>
          <span className="text-gray-300">/</span>
          <span className="text-sm font-medium text-gray-800 truncate max-w-xs">{fullName}</span>
        </div>
        {/* ✅ Hide "Create & Assign Company" button when company is already associated */}
        {!hasAssociatedCompany && (
          <button
            onClick={() => setShowCreateAssignCompanyModal(true)}
            className="flex items-center gap-2 px-4 py-2 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors font-medium"
          >
            <Building2 size={15} /> Create &amp; Assign Company
          </button>
        )}
      </div>

      {/* ── 3-column layout ── */}
      <div className="flex h-[calc(100vh-49px)] overflow-hidden">

        {/* ── LEFT SIDEBAR — contact details ── */}
        <aside className="w-64 bg-white border-r border-gray-200 flex-shrink-0 h-full overflow-y-auto">
          <div className="p-4 border-b border-gray-100">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 text-orange-700 font-bold text-sm">
                {initials}
              </div>
              <div className="min-w-0">
                <h2 className="font-semibold text-gray-900 text-sm leading-tight">{fullName}</h2>
                <p className="text-xs text-gray-400 mt-0.5">{contact.jobTitle || 'Contact'}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {contact.leadStatus && <Badge value={contact.leadStatus} config={LEAD_STATUS_CONFIG} />}
              {contact.doNotEmail && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border bg-red-50 border-red-200 text-red-600">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-500 flex-shrink-0" />
                  Do Not Email
                </span>
              )}
              {contact.doNotCall && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border bg-amber-50 border-amber-200 text-amber-600">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-500 flex-shrink-0" />
                  Do Not Call
                </span>
              )}
            </div>
          </div>
          <div className="p-4">
            <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-2">Contact Details</p>
            {fields.map(field => (
              <SidebarField
                key={field.key}
                field={field}
                editingField={editingField}
                editValues={editValues}
                display={getDisplay(field)}
                onEdit={() => setEditingField(field.key)}
                onSave={() => handleSidebarSave(field.key)}
                onCancel={handleSidebarCancel}
                onChange={(e) => setEditValues(p => ({ ...p, [field.key]: e.target.value }))}
              />
            ))}
          </div>
        </aside>

        {/* ── CENTER PANEL — notes + tasks + activity ── */}
        <main className="flex-1 h-full overflow-y-auto min-w-0">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 flex items-center gap-3">
            <ListChecks size={20} className="text-white/80" />
            <h1 className="text-white font-semibold text-lg tracking-wide">Lead Activity Tracker</h1>
          </div>

          <div className="p-5 space-y-5 max-w-2xl">

            {/* ══ NOTES ══ */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
                <div className="flex items-center gap-2.5">
                  <div className="w-6 h-6 rounded-md bg-gray-800 flex items-center justify-center">
                    <FileText size={12} className="text-white" />
                  </div>
                  <span className="text-sm font-semibold text-gray-800">Notes</span>
                  {contact?.notesLastEditedAt && (
                    <span className="text-xs text-gray-400">
                      · Last edited by {employeeNameCache[contact.notesLastEditedBy] || contact.notesLastEditedBy} on {new Date(contact.notesLastEditedAt).toLocaleString()}
                    </span>
                  )}
                </div>
                {notes && !editingNotes && (
                  <button onClick={() => { setNotesDraft(notes); setEditingNotes(true); }}
                    className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors font-medium">
                    <Edit2 size={12} /> Edit
                  </button>
                )}
              </div>
              <div className="px-5 py-4">
                {notesLoading ? (
                  <div className="flex items-center justify-center py-8">
                    <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : editingNotes ? (
                  <div>
                    <textarea ref={textareaRef} value={notesDraft}
                      onChange={e => setNotesDraft(e.target.value)} rows={6}
                      className="w-full px-4 py-3 text-sm text-gray-700 leading-relaxed bg-blue-50 border border-blue-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
                      placeholder="Write notes about this contact…" />
                    <div className="flex items-center justify-between mt-3">
                      <span className="text-xs text-gray-400">{notesDraft.length} characters</span>
                      <div className="flex items-center gap-2">
                        <button onClick={handleCancelNotes}
                          className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors font-medium">
                          <RotateCcw size={11} /> Cancel
                        </button>
                        <button onClick={handleSaveNotes} disabled={notesSaving}
                          className="flex items-center gap-1.5 px-4 py-1.5 text-xs text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors font-medium disabled:opacity-50">
                          <Save size={11} /> {notesSaving ? 'Saving…' : 'Save Notes'}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : notes ? (
                  <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">{notes}</p>
                ) : (
                  <div className="text-center py-6">
                    <FileText size={24} className="text-blue-200 mx-auto mb-2" />
                    <p className="text-sm text-gray-400 mb-3">No notes yet</p>
                    <button onClick={() => { setNotesDraft(''); setEditingNotes(true); }}
                      className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium mx-auto">
                      <Plus size={14} /> Add Notes
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* ══ TASKS ══ */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
                <div className="flex items-center gap-2.5">
                  <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
                    <ListChecks size={12} className="text-white" />
                  </div>
                  <span className="text-sm font-semibold text-gray-800">Tasks</span>
                  {tasks.length > 0 && (
                    <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-blue-100 text-blue-700">
                      {tasks.length}
                    </span>
                  )}
                </div>
                <button
                  onClick={() => setShowCreateTaskModal(true)}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                >
                  <Plus size={13} /> Create Task
                </button>
              </div>
              <div className="p-4">
                {tasksLoading ? (
                  <div className="flex items-center justify-center py-10">
                    <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : tasks.length === 0 ? (
                  <div className="text-center py-8">
                    <CheckCircle2 size={28} className="text-gray-200 mx-auto mb-2" />
                    <p className="text-sm text-gray-400 mb-3">No tasks for this contact</p>
                    <button
                      onClick={() => setShowCreateTaskModal(true)}
                      className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                    >
                      <Plus size={13} /> Create Task
                    </button>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {tasks.map(task => (
                      <TaskCard key={task.id} task={task} onEdit={setEditingTask} />
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* ══ ACTIVITY ══ */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <div className="flex items-center gap-2.5 px-5 py-3 border-b border-gray-100 bg-gray-50">
                <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
                  <Activity size={12} className="text-white" />
                </div>
                <span className="text-sm font-semibold text-gray-800">Activity</span>
              </div>
              <div className="p-4">
                {tasks.length > 0 && (
                  <div className="grid grid-cols-4 gap-3 mb-4">
                    {[
                      { label: 'Total',       value: taskCounts.total,      color: 'text-gray-700',  bg: 'bg-gray-50 border-gray-200' },
                      { label: 'Pending',     value: taskCounts.pending,    color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200' },
                      { label: 'In Progress', value: taskCounts.inProgress, color: 'text-blue-600',  bg: 'bg-blue-50 border-blue-200' },
                      { label: 'Completed',   value: taskCounts.completed,  color: 'text-green-600', bg: 'bg-green-50 border-green-200' },
                    ].map(s => (
                      <div key={s.label} className={`rounded-lg border p-3 text-center ${s.bg}`}>
                        <p className={`text-xl font-bold ${s.color}`}>{s.value}</p>
                        <p className="text-xs text-gray-500 mt-0.5">{s.label}</p>
                      </div>
                    ))}
                  </div>
                )}
                {tasksLoading ? (
                  <div className="flex items-center justify-center py-10">
                    <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : tasks.length === 0 ? (
                  <div className="text-center py-8">
                    <Activity size={28} className="text-gray-200 mx-auto mb-2" />
                    <p className="text-sm text-gray-400">No activity yet</p>
                    <p className="text-xs text-gray-300 mt-1">Tasks and interactions will appear here</p>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {tasks.map(task => (
                      <TaskCard key={task.id} task={task} onEdit={setEditingTask} />
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="h-4" />
          </div>
        </main>

        {/* ── RIGHT PANEL — associated company ── */}
        <aside className="w-72 bg-white border-l border-gray-200 flex-shrink-0 h-full overflow-y-auto">
          <div className="px-4 py-3.5 border-b border-gray-100 bg-gray-50 sticky top-0 z-10">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
                  <Building2 size={12} className="text-white" />
                </div>
                <span className="text-sm font-semibold text-gray-800">Associated Company</span>
              </div>
              <button onClick={fetchAssociatedCompany}
                className="p-1 rounded hover:bg-gray-200 transition-colors" title="Refresh">
                <RefreshCw size={13} className="text-gray-400" />
              </button>
            </div>
          </div>

          <div className="p-3">
            {associatedCompanyLoading ? (
              <div className="flex items-center justify-center py-16">
                <div className="flex flex-col items-center gap-2">
                  <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                  <p className="text-xs text-gray-400">Loading company…</p>
                </div>
              </div>
            ) : associatedCompanyError ? (
              <div className="text-center py-12 px-3">
                <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-3">
                  <Building2 size={20} className="text-red-300" />
                </div>
                <p className="text-sm font-medium text-gray-500 mb-1">Failed to load</p>
                <button onClick={fetchAssociatedCompany} className="mt-2 text-xs text-blue-600 hover:underline">
                  Try again
                </button>
              </div>
            ) : associatedCompany ? (
              <>
                <AssociatedCompanyCard
                  company={associatedCompany}
                  onNavigate={(companyId) => navigate(`/company/${companyId}`)}
                />
                {/* ✅ Edit Company button only shown when company IS associated */}
                <button
                  onClick={() => setEditingCompany(associatedCompany)}
                  className="w-full mt-3 inline-flex items-center justify-center gap-2 px-4 py-2 text-xs font-semibold bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors border border-blue-200"
                >
                  <Edit2 size={12} /> Edit Company
                </button>
              </>
            ) : (
              /* ✅ "Create & Assign" in right panel only when NO company is linked */
              <div className="text-center py-12 px-3">
                <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-3">
                  <Building2 size={20} className="text-blue-300" />
                </div>
                <p className="text-sm font-medium text-gray-500 mb-1">No company linked</p>
                <p className="text-xs text-gray-400 leading-relaxed mb-4">
                  Assign a company to this contact by setting the Company ID in the sidebar or using "Create &amp; Assign Company".
                </p>
                <button
                  onClick={() => setShowCreateAssignCompanyModal(true)}
                  className="inline-flex items-center gap-2 px-4 py-2 text-xs font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                >
                  <Plus size={12} /> Create &amp; Assign
                </button>
              </div>
            )}
          </div>
        </aside>

      </div>

      {/* ══ MODALS & DRAWERS ══ */}
      {showCreateAssignCompanyModal && (
        <CreateAssignCompanyModal
          onClose={() => setShowCreateAssignCompanyModal(false)}
          onAssigned={handleCompanyAssigned}
          contactId={id}
        />
      )}

      {showCreateTaskModal && (
        <CreateTaskModal
          onClose={() => setShowCreateTaskModal(false)}
          onCreate={() => {
            setShowCreateTaskModal(false);
            toast.success('Task created successfully');
            fetchTasks();
          }}
          linkedContact={contact.id}
          linkedContactName={fullName}
          linkedAccount={associatedCompany?.id || lastAssignedCompany?.id || ''}
          linkedAccountName={associatedCompany?.companyName || lastAssignedCompany?.name || ''}
        />
      )}

      {editingTask && (
        <TaskEditDrawer
          task={editingTask}
          onClose={() => setEditingTask(null)}
          onSave={handleTaskEditSave}
        />
      )}

      {editingCompany && (
        <CompanyEditDrawer
          company={editingCompany}
          onClose={() => setEditingCompany(null)}
          onSave={() => {
            setEditingCompany(null);
            fetchAssociatedCompany();
          }}
        />
      )}
    </div>
  );
};

export default ContactPreviewPage;